import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "wpcm-recurring-btns" }
const _hoisted_3 = {
  key: 0,
  class: "d-inline-flex"
}
const _hoisted_4 = { class: "wpcm-payment-gateways mt-3" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "wpcm-gateway-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Form Builder Renderer for Step 3 "),
    ($props.use_form_builder && $props.form_builder_config)
      ? (_openBlock(), _createBlock($setup["FormBuilderRenderer"], {
          key: 0,
          "form-builder-config": $props.form_builder_config,
          step: "step_3",
          gateways: $props.gateways
        }, null, 8 /* PROPS */, ["form-builder-config", "gateways"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Legacy Fields (Fallback) "),
          _createElementVNode("div", _hoisted_2, [
            ($props.show_recurring)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  ($props.strings)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        class: "m-0",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.setRecurring(false)), ["prevent"]))
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass(!$setup.store.recurring && 'active')
                        }, _toDisplayString($props.strings.one_time), 3 /* TEXT, CLASS */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($props.strings)
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: "m-0",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.setRecurring(true)), ["prevent"]))
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass($setup.store.recurring && 'active')
                        }, _toDisplayString($props.strings.recurring), 3 /* TEXT, CLASS */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              ($props.gateways)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.gateways, (gateway, gateway_id) => {
                      return (_openBlock(), _createElementBlock("li", { key: gateway_id }, [
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => ($setup.store.payment_method = gateway.id), ["prevent"]),
                          class: _normalizeClass([(gateway.id === $setup.store.payment_method) && 'active']),
                          title: "",
                          href: "#"
                        }, [
                          (gateway.icon)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                _createElementVNode("img", {
                                  src: gateway.icon,
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_9)
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" " + _toDisplayString(gateway.title ? gateway.title : gateway.name), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_7)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _renderSlot(_ctx.$slots, "gateway_data"),
            _renderSlot(_ctx.$slots, "billing_info"),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}